import { useLoyaltyStatusQuery } from '@generated'
import { getLoyaltyProgress } from '@lib/get-loyalty-progress'
import { getMembershipName } from '@lib/get-membership-name'
import { getMembershipNo } from '@lib/get-membership-no'

export function useLoyaltyStatus() {
  const [{ data, fetching }] = useLoyaltyStatusQuery()
  let membershipName: string | undefined = undefined
  let membershipNo: number | undefined = undefined
  let progress: number | undefined = undefined
  let isNoPremiumMember = true

  if (data) {
    membershipName = getMembershipName(data)
    membershipNo = getMembershipNo(data)
    progress = getLoyaltyProgress(data)
    isNoPremiumMember = membershipNo === 5
  }

  return {
    loading: fetching,
    membershipName,
    membershipNo,
    isNoPremiumMember,
    progress,
  }
}
